import { DataSecurityLevel, KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { generateEvent } from '../InstrumentationService';
export function logPerformanceEvent(eventName, latency, params, securityThreshold) {
    if (params === void 0) { params = {}; }
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    params["Latency" /* Latency */] = latency.toString();
    generateEvent(eventName, KnownInstrumentationEvents.PerformanceDump, securityThreshold, params, [], true);
}
//# sourceMappingURL=logPerformanceEvent.js.map